import { SongsService } from './../../api/services/songs-service';
import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChange,AfterViewInit } from '@angular/core';
import { PlayerService } from '../../player';
import { PlaylistService, ScrollService, AlbumsService, ArtistService, LoggingService } from '../../api';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import * as _ from 'lodash';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
@Component({
  selector: 'play',
  templateUrl: './play.component.html',
  styleUrls: ['./play.component.css']
})
export class PlayComponent implements OnInit, OnDestroy, OnChanges {
  @Input() item: any;
  @Input() autoPlay:  boolean = false;
  private songId: number = 0;
  private playerSongId: number = 0;
  private tooltip: any;
  private isThisSongPlaying: boolean = false;
  private playerEventSubscriber = null;
  private playStatusString = 'PLAY';
  private type: string = '';
  private playlistQue2 = [];

  @BlockUI() blockUI: NgBlockUI;
  private songs: any = new Array<any>();
  localStorageSongs: any;
  creditsArray: any[];
  song: any;
  private lyricSlice: number = 400;

  constructor(public dialog: MdDialog,private route: ActivatedRoute, private playerService: PlayerService, private playlistService: PlaylistService,
  private songService: SongsService, private artistService: ArtistService, private scrollService: ScrollService, private albumService: AlbumsService, private loggingService: LoggingService) {
    this.playerService.isSongPlayingStatus.subscribe(res => {
      if(res == false) {
        this.isThisSongPlaying = false;
      }
    })
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    this.songId = this.item.id;
    let itemType = (typeof this.item !== 'undefined' && typeof this.item._type !== 'undefined') ? this.item._type : 'song';
    switch (itemType) {
      case 'song':
        this.tooltip = '_SONG';
        break;
      case 'album':
        this.tooltip = '_ALBUM';
        break;
      case 'artist':
        this.tooltip = '_ARTIST';
        break;
      case 'playlist':
        this.tooltip = this.item.type === 'R' ? '_RADIO' : '_PLAYLIST';
        break;
      default:
        // this.tooltip = this.playStatusString;
        break;
    }
    if(this.item._type === 'song') {
      this.isThisSongPlaying = this.playerService.getCurrentTrack() === this.songId;
      if(this.playerService.getCurrentTrack() === this.songId) {
        this.isThisSongPlaying = true;
      }
      this.playerEventSubscriber = this.playerService.playerEvent.subscribe((event) => {
        if(event.type === 'track:id' && event.data === this.songId) {
          this.isThisSongPlaying = true;
          this.playStatusString = 'PAUSE';
        }
        else if(event.type === 'track:id' && event.data !== this.songId) {
          this.isThisSongPlaying = false;
          this.playStatusString = 'PLAY';
        }
        if(this.isThisSongPlaying === true && event.type === 'music:isPlaying' && event.data === false) {
          this.isThisSongPlaying = false;
          this.playStatusString = 'PLAY';
        }
      });
    } else if(this.item._type == 'playlist') {
      let currentTrackId = this.playerService.getCurrentTrack();
      if(this.item.songsId.includes(currentTrackId)) {
        if(this.playerService.isPlayingStatus() == true) {
          this.isThisSongPlaying = this.playerService.getCurrentTrack() === currentTrackId;
        }
      } else {
        this.isThisSongPlaying = false;
      }
    }
  }

  ngOnInit() {
    if(screen.width <= 1024) {
      this.lyricSlice = 215;
    } else if(screen.width <= 1400) {
      this.lyricSlice = 400;
    } else if(screen.width <= 3070) {
      this.lyricSlice = 550;
    } else {
      this.lyricSlice = 700;
    }
    if(this.item._type == 'song') {
      this.isThisSongPlaying = this.playerService.getCurrentTrack() === this.songId;
    } else if(this.item._type == 'playlist') {
      let currentTrackId = this.playerService.getCurrentTrack();
      if(this.item.songsId.includes(currentTrackId)) {
        if(this.playerService.isPlayingStatus() == true) {
          this.isThisSongPlaying = this.playerService.getCurrentTrack() === currentTrackId;
        }
      } else {
        this.isThisSongPlaying = false;
      }
    }
  }

  playFromArray(songs: any[], playedFrom: any = false) {
    let item = this.item;
    if(songs) {
      this.playerService.clearPlaylist(() => {
        //cleared playlist
      });
    songs.forEach((song, index) => {
      if(item._type === 'playlist') {
        let logData = {
          playedFrom: 'playlist',
          playlistId: item.id,
          parentId: item.id,
          parentName: item.name,
          parentSlug: item.slug,
          firstSong: (index === 0) ? true : false
        };
        song.logData = logData;
        if(item.type === 'R') {
          song.belongsToRadio = true;
        } else {
          song.belongsToRadio = false;
        }
      }
      if(playedFrom === 'album') {
        let logData = {
          playedFrom: 'album',
          parentId: item.id,
          parentName: item.name,
          parentSlug: item.slug,
          firstSong: (index === 0) ? true : false
        };
        song.logData = logData;
      } else if(playedFrom === 'artist') {
        let logData = {
          playedFrom: 'artist',
          parentId: item.id,
          parentName: item.name,
          parentSlug: item.slug,
          firstSong: (index === 0) ? true : false
        };
        song.logData = logData;
      }
      if(index === 0) {
        this.item = song;
        let trackId = this.playerService.addTrack(song);
        this.playerService.playTrack(trackId);
        this.playerService.showLoading(false);
      } else {
        this.playerService.addTrack(song);
      }
    });
    }
  }

  play(event: any = false) {
    this.song = this.item;
    // Storing the song detail in local storage when the song is played
    if(this.item._type == "song") {
      var localSong = [];
      this.localStorageSongs = JSON.parse(localStorage.getItem("songDetail"));
      if(this.localStorageSongs) {
        localSong = this.localStorageSongs.filter(x => x.slug == this.song.slug);
      } else {
        this.localStorageSongs = [];
      }
      if(localSong.length == 0) {
        if(this.song.credits && this.song.credits.length != 0) {
          if(this.song.lyrics != null) {
            this.song.songLyrics = this.song.lyrics;
            this.item.songLyrics2 = this.item.songLyrics.slice(0, this.lyricSlice);
          }
          this.removeSlash();
          this.removeDuplicatCredits();
          this.localStorageSongs.push(this.song);
            // storing the song in local storage to avoid extra API calls
          localStorage.setItem("songDetail" , JSON.stringify(this.localStorageSongs));
        } else {
          this.songService.getSongDetailBySlug(this.song.slug).subscribe(res => {
            this.song = res;
            if(res.lyrics != null) {
              this.song.songLyrics = res.lyrics;
              this.song.songLyrics2 = res.songLyrics.slice(0, this.lyricSlice);
            }
            this.removeSlash();
            this.removeDuplicatCredits();
            this.localStorageSongs.push(this.song);
            // storing the song in local storage to avoid extra API calls
            localStorage.setItem("songDetail" , JSON.stringify(this.localStorageSongs));
          })
        }
      }
    }
    this.playerService.showLoading(true);
    if (event !== false) {
      event.stopPropagation();
      event.preventDefault();
    }

    if(this.item._type == "song") {
      if (this.playerService.getCurrentTrack() === this.songId) {
        this.playerService.play();
        this.playerService.showLoading(false);
        return;
      }
    }
    // else if(this.item._type == "playlist" && this.playerService.getCurrentTrack() != null) {
    //   if(this.item.songsId.includes(this.playerService.getCurrentTrack())) {
    //     this.isThisSongPlaying = true;
    //     this.playerService.play();
    //     this.playerService.showLoading(false);
    //     return;
    //   }
    // }

    this.blockUI.start('Loading, please wait...');

    let songs: any;
    let itemType = (typeof this.item !== 'undefined' && typeof this.item._type !== 'undefined') ? this.item._type : 'playlist';
    let currentTrackData = this.playerService.currentTrackData();
    //Playing helper for every media type except radio...
    /****** Play Helper ******/
    let playHelper = (itemType) => {
      let share_id='-1';
      if((localStorage.getItem('share_id')!=null)){
        share_id= localStorage.getItem('share_id');
      }
      switch (itemType) {
        case 'album':
          this.albumService.fetchSongs(this.item).subscribe((songs) => {
            this.playFromArray(songs, 'album');
          });
          this.playerService.showLoading(false);
          this.isThisSongPlaying = true;
          setTimeout(() => {
            this.blockUI.stop();
          }, 2000);
          break;
        case 'playlist':
          this.playlistService.fetchSongs(this.item).subscribe((songs) => {
            let playlist = this.item;
            this.playerService.showLoading(false);
            if (songs.length > 0 && this.item.type !== 'R') {
              let params = { indication_1: playlist.id, indication_2: songs[0].id, domain_2: 's',share_id:share_id };
              this.loggingService.logEntity('playlist', params).subscribe((res) => { });
            } else if (songs.length > 0 && this.item.type !== 'R') {
              // radio logging here
            }
              if (songs.length > 0)
                this.playFromArray(songs, playlist);
          });
          this.isThisSongPlaying = true;
          setTimeout(() => {
            this.blockUI.stop();
          }, 2000);
          break;
        case 'song':
          this.setLogDataForSingleSong();
          let inArrayKey = this.playerService.checkifsonginQue(this.item);
          let trackId = this.playerService.addTrack(this.item);
          this.playerService.playTrack(trackId);
          this.playerService.showLoading(false);
          this.isThisSongPlaying = true;
          setTimeout(() => {
            this.blockUI.stop();
          }, 2000);
          break;
        case 'artist':
          this.blockUI.start('Loading, please wait...');
          songs = this.artistService.fetchSongs(this.item).subscribe((songs) => {
            this.playFromArray(songs, 'artist');
            this.playerService.showLoading(false);
            // log that the artist was played
            if (songs.length > 0) {
              let params = { indication_1: this.item.artist.id, indication_2: songs[0].id, domain_2: 's',share_id:share_id  };
              this.loggingService.logEntity('artist', params).subscribe((res) => { });
            }
            this.blockUI.stop();
          });
          this.isThisSongPlaying = true;
          break;
      }
    };

    /****** Play Helper ******/
    /****** Play radio ******/
    let playRadio = () => {
      let logData = {
        playedFrom: 'playlist',
        playlistId: this.item.id,
        parentId: this.item.id,
        parentName: this.item.name,
        parentSlug: this.item.slug,
      };
      this.item.logData = logData;
      this.playerService.playRadio(this.item);
    };
    /****** Play radio ******/

    if (this.item.type === 'R' && 'playlist' === itemType) {
      this.playerService.stop();
      this.playerService.setCurrentTrack(null);
        //cleared playlist
      this.playerService.clearPlaylist(() => {
        //cleared playlist
        playRadio();
        this.playerService.showLoading(false);
      });
      localStorage.setItem('RadioName', this.item.name);

    } else {
      playHelper(itemType); // a normal play doesn't require radio....
    }
    if(screen.width <= 668){
    setInterval(()=> {
      if (document.getElementById("corner-logo")){
        document.getElementById("corner-logo").style.width = null;
      document.getElementById("corner-logo").style.height = '120px';
      document.getElementById("corner-logo").style.left = '222.5px';
    }
      if(document.getElementById("preview")){
        document.getElementById('preview').style.bottom = '18%'
      }
      },50)
    }
  }

  pause(event: any = false) {
    if (event !== false) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.playerService.pause();
    this.isThisSongPlaying = false;
    localStorage.removeItem("blinkText");
  }

  setLogDataForSingleSong() {
    // if a single song from albums is played, set logging data here
    if (this.item.playedFrom && this.item.playedFrom === 'album') {
      let logData = {
        playedFrom: 'album',
        parentId: this.item.album.id,
        parentName: this.item.album.name,
        parentSlug: this.item.album.slug,
        firstSong: true
      };
      this.item.logData = logData;
    } else if (this.item.playedFrom && this.item.playedFrom === 'artist') {
      let logData = {
        playedFrom: 'artist',
        parentId: this.item.artist.id,
        parentName: this.item.artist.name,
        parentSlug: this.item.artist.slug,
        firstSong: true
      };
      this.item.logData = logData;
    } else if (this.item.playedFrom && this.item.playedFrom === 'playlist') {
      let logData = {
        playedFrom: 'playlist',
        firstSong: true,
        parentId: this.item.parentId, //just adding these options twice as some stuff is not handled properly
        parentName: this.item.parentName,
        parentSlug: this.item.parentSlug,
        playlistId: this.item.playlistId
      };
      this.item.logData = logData;
    } else if (!this.item.playedFrom && this.item._type === 'song') {
      let logData = {
        playedFrom: 'song',
          parentName: (this.item.album != null && this.item.album.image != null && this.item.album.image.trim() !== '') ? this.item.album.name : this.item.artist.name,
          parentSlug: (this.item.album != null && this.item.album.image != null && this.item.album.image.trim() !== '') ? this.item.album.slug : this.item.artist.slug
      };
      this.item.logData = logData;
    }
  }

  removeSlash() {
    if (this.song) {
      if (typeof this.song.credits === "object" && this.song.credits != null) {
        for (var i = 0; i < this.song.credits.length; i++) {
          this.song.credits[i].credit_type = this.song.credits[i].credit_type.replace("_", " ");
          this.song.credits[i].credit_type = this.song.credits[i].credit_type.charAt(0).toUpperCase() + this.song.credits[i].credit_type.slice(1);
        }
      }
    }
  }

  removeDuplicatCredits() {
    for (let e = 0; e < 4; e++) {
      if(this.song.writers) {
        this.song.writers.forEach((song, index) => {
            // Compare the writer names and remove the duplicate record
          if (index !== this.song.writers.findIndex(i => i.writer === song.writer)) {
            this.song.writers.splice(index, 1);
          }
        });
      }
    }

    for (let f = 0; f < 4; f++) {
      this.creditsArray = new Array<any>();
      if(this.song.credits) {
        this.song.credits.forEach((song, index) => {
          if (index !== this.song.credits.findIndex(i => i.credit_type === song.credit_type)) {
            this.creditsArray.push(this.song.credits[index]);
          }
        });
      }
    }

    for (let j = 0; j < this.creditsArray.length; j++) {
      for (let k = 0; k < this.song.credits.length; k++) {
        if (this.song.credits[k].credit_type == this.creditsArray[j].credit_type) {
          if (!(this.song.credits[k].name.includes(this.creditsArray[j].name))) {
            if (!this.song.credits[k].values) {
              this.song.credits[k]["values"] = [];
            }
            if (!(this.song.credits[k].values.includes(this.song.credits[k].name))) {
              this.song.credits[k].values.push(this.song.credits[k].name);
            }
            if (!(this.song.credits[k].values.includes(this.creditsArray[j].name))) {
              this.song.credits[k].values.push(this.creditsArray[j].name);
            }
          }
        }
      }
    }

    for (let f = 0; f < 4; f++) {
      this.creditsArray = new Array<any>();
      if(this.song.credits) {
        this.song.credits.forEach((song, index) => {
          if (index !== this.song.credits.findIndex(i => i.credit_type === song.credit_type)) {
            this.creditsArray.push(this.song.credits[index]);
            this.song.credits.splice(index, 1);
          }
        });
      }
    }

    if(this.song.credits) {
      for(let k = 0; k < this.song.credits.length; k++) {
        if(!this.song.credits[k].values) {
          this.song.credits[k]["values"] = [];
        }
        if(!(this.song.credits[k].values.includes(this.song.credits[k].name))) {
          let locationPartt = this.song.credits[k].name.split(",");
          for (let p = 0; p < locationPartt.length; p++) {
            locationPartt[p].replace(",", "");
            this.song.credits[k].values.push(locationPartt[p]);
          }
        }
        if(this.song.credits[k].location && this.song.credits[k].location != null) {
          this.song.credits[k]["locations"] = [];
          let locationParts = this.song.credits[k].location.split(",");
          for (let m = 0; m < locationParts.length; m++) {
            if (!(locationParts[m].includes("."))) {
              this.song.credits[k].locations.push(locationParts[m]);
            } else {
              let locationParts2 = locationParts[m].split(".");
              for (let n = 0; n < locationParts2.length; n++) {
                this.song.credits[k].locations.push(locationParts2[n]);
              }
            }
          }
        }
      }
    }

    //publisher array making
    if(!this.song.publishers) {
      //console.log("checking song"+this.song);
      this.song["publisherss"] = [];
      if(this.song.publisher || (typeof this.song.publisher != 'undefined')){
        var locationParttt = this.song.publisher.split(",");
        for (let p = 0; p < locationParttt.length; p++) {
          locationParttt[p].replace(",", "");
          if(typeof this.song.publisherss != 'undefined') {
            this.song.publisherss.push(locationParttt[p]);
          }
        }
      }

    } else {
      this.song["publisherss"] = [];
      for (let m = 0; m < this.song.publishers.length; m++) {
        if (this.song.publishers[m].publisher) {
          this.song.publisherss.push(this.song.publishers[m].publisher);
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.playerEventSubscriber != null) {
      this.playerEventSubscriber.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/play/play.component.ts